import { BurgerProps } from '../'

export const defaultProps: Record<string, unknown> = {
  size: 32,
  direction: 'left',
  distance: 'md',
  duration: 0.4,
  label: 'hamburger',
  easing: 'cubic-bezier(0, 0, 0, 1)',
  pressed: false
};
